import { Reducer } from 'redux';

// Constants
import ITINERARY_CONST from 'constants/itineraries';

import { ItinerariesState, ItinerariesTypes } from './types';

const INITIAL_STATE: ItinerariesState = {
  itineraryData: {
    id: '',
    name: '',
    weekdays: [],
    status: ITINERARY_CONST.STATUS.ACTIVE.KEY,
    departureTime: '',
    arrivalTime: '',
    lineId: '',
    lineSectionId: '',
    createdAt: '',
    updatedAt: '',
  },
  itineraryResumeList: [],
  itinerariesList: [],
  itinerariesByWeekdaysList: [],
  currentLine: {
    id: '',
    name: '',
    prefix: '',
    status: 0,
    visible: false,
    sellingAllowed: true,
    type: 0,
    distributionType: 0,
    lineType: 0,
    lineFunction: 0,
    model: 0,
    sector: '',
    system: '',
    operation: 0,
    color: '',
    minVelocity: 0,
    maxVelocity: 0,
    updatedAt: '',
    createdAt: '',
    lineLotId: '',
    transportOperatorId: '',
  },
  itineraryResumeTripCapacityList: [],
  tokenList: [],
  bpeList: [],
  userTransactionList: [],
  vehicleLicense: null,
  totalCount: 0,
  error: false,
  loading: false,
  vehicleLicenseLoading: false,
  vehicleLicenseCalled: false,
  vehicleLicenseError: false,
  isCompleted: false,
  token: null,
};

const reducer: Reducer<ItinerariesState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST ITINERARIES
    case ItinerariesTypes.LIST_ITINERARIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itinerariesList: INITIAL_STATE.itinerariesList,
      };
    case ItinerariesTypes.LIST_ITINERARIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itinerariesList: action.payload.itinerariesList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.LIST_ITINERARIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itinerariesList: INITIAL_STATE.itinerariesList,
      };

    // CASES LIST ITINERARIES BY WEEKDAY
    case ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itinerariesByWeekdaysList: INITIAL_STATE.itinerariesByWeekdaysList,
      };
    case ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itinerariesByWeekdaysList: action.payload.itinerariesByWeekdaysList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.LIST_ITINERARIES_BY_WEEKDAYS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itinerariesByWeekdaysList: INITIAL_STATE.itinerariesByWeekdaysList,
      };

    // CASES GET ITINERARY
    case ItinerariesTypes.GET_ITINERARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itineraryData: INITIAL_STATE.itineraryData,
      };
    case ItinerariesTypes.GET_ITINERARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itineraryData: action.payload.itineraryData,
      };
    case ItinerariesTypes.GET_ITINERARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itineraryData: INITIAL_STATE.itineraryData,
      };

    // CASES FILTER ITINERARIES
    case ItinerariesTypes.FILTER_ITINERARIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itinerariesList: INITIAL_STATE.itinerariesList,
      };
    case ItinerariesTypes.FILTER_ITINERARIES_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itinerariesList: action.payload.itinerariesList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.FILTER_ITINERARIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itinerariesList: INITIAL_STATE.itinerariesList,
      };

    // CASES CREATE ITINERARY
    case ItinerariesTypes.CREATE_ITINERARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itineraryData: INITIAL_STATE.itineraryData,
      };
    case ItinerariesTypes.CREATE_ITINERARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itineraryData: action.payload.itineraryData,
      };
    case ItinerariesTypes.CREATE_ITINERARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itineraryData: INITIAL_STATE.itineraryData,
      };

    // CASES UPDATE ITINERARY
    case ItinerariesTypes.UPDATE_ITINERARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.UPDATE_ITINERARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itineraryData: action.payload.itineraryData,
      };
    case ItinerariesTypes.UPDATE_ITINERARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE ITINERARY
    case ItinerariesTypes.DELETE_ITINERARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.DELETE_ITINERARY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ItinerariesTypes.DELETE_ITINERARY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES LIST RESUME ITINERARY
    case ItinerariesTypes.RESUME_ITINERARY_REQUEST:
      return {
        ...state,
        loading: true,
        isCompleted: false,
        error: false,
        itineraryResumeList: INITIAL_STATE.itineraryResumeList,
      };
    case ItinerariesTypes.RESUME_ITINERARY_SUCCESS:
      return {
        ...state,
        loading: false,
        isCompleted: true,
        error: false,
        itineraryResumeList: action.payload.itineraryResumeList,
      };
    case ItinerariesTypes.RESUME_ITINERARY_FAILURE:
      return {
        ...state,
        isCompleted: false,
        loading: false,
        error: true,
        itineraryResumeList: INITIAL_STATE.itineraryResumeList,
      };

    case ItinerariesTypes.SET_CURRENT_LINE:
      return {
        ...state,
        currentLine: action.payload.currentLine,
      };

    // CASES RESUME ITINERARY TRIP CAPACITY REQUEST
    case ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        itineraryResumeTripCapacityList:
          INITIAL_STATE.itineraryResumeTripCapacityList,
      };
    case ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        itineraryResumeTripCapacityList:
          action.payload.itineraryResumeTripCapacityList,
      };
    case ItinerariesTypes.RESUME_ITINERARY_TRIP_CAPACITY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        itineraryResumeTripCapacityList:
          INITIAL_STATE.itineraryResumeTripCapacityList,
      };

    // CASES PEDESTRIAN TOKENS REQUEST
    case ItinerariesTypes.PEDESTRIAN_TOKENS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.PEDESTRIAN_TOKENS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ItinerariesTypes.PEDESTRIAN_TOKENS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES VEHICLE TOKENS REQUEST
    case ItinerariesTypes.VEHICLE_TOKENS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.VEHICLE_TOKENS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ItinerariesTypes.VEHICLE_TOKENS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES RESCHEDULE TOKEN REQUEST
    case ItinerariesTypes.RESCHEDULE_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.RESCHEDULE_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ItinerariesTypes.RESCHEDULE_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES SEAT PRE RESERVE REQUEST
    case ItinerariesTypes.SEAT_PRE_RESERVE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ItinerariesTypes.SEAT_PRE_RESERVE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ItinerariesTypes.SEAT_PRE_RESERVE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES FILTER VEHIVLE LICENSE REQUEST
    case ItinerariesTypes.FILTER_VEHIVLE_LICENSE_REQUEST:
      return {
        ...state,
        vehicleLicenseLoading: true,
        vehicleLicenseCalled: true,
        vehicleLicenseError: false,
        vehicleLicense: INITIAL_STATE.vehicleLicense,
      };
    case ItinerariesTypes.FILTER_VEHIVLE_LICENSE_SUCCESS:
      return {
        ...state,
        vehicleLicenseLoading: false,
        vehicleLicenseError: false,
        vehicleLicense: {
          ...action.payload.vehicleLicense,
          license: action.payload.license,
        },
      };
    case ItinerariesTypes.FILTER_VEHIVLE_LICENSE_FAILURE:
      return {
        ...state,
        vehicleLicenseLoading: false,
        vehicleLicenseError: true,
      };

    // CASES TOKEN LIST REQUEST
    case ItinerariesTypes.TOKEN_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        tokenList: INITIAL_STATE.tokenList,
      };
    case ItinerariesTypes.TOKEN_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        tokenList: action.payload.tokenList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.TOKEN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        tokenList: INITIAL_STATE.tokenList,
      };

    // CASES USER TRASACTION LIST REQUEST
    case ItinerariesTypes.USER_TRASACTION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        userTransactionList: INITIAL_STATE.userTransactionList,
      };
    case ItinerariesTypes.USER_TRASACTION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        userTransactionList: action.payload.userTransactionList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.USER_TRASACTION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        userTransactionList: INITIAL_STATE.userTransactionList,
      };

    // CASES BPE LIST REQUEST
    case ItinerariesTypes.BPE_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        bpeList: INITIAL_STATE.bpeList,
      };
    case ItinerariesTypes.BPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        bpeList: action.payload.bpeList,
        totalCount: action.payload.totalCount,
      };
    case ItinerariesTypes.BPE_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        bpeList: INITIAL_STATE.bpeList,
      };

    // CASES GET CARD REQUEST
    case ItinerariesTypes.GET_3DS_TOKEN_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        token: INITIAL_STATE.token,
      };
    case ItinerariesTypes.GET_3DS_TOKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        token: action.payload.token,
      };
    case ItinerariesTypes.GET_3DS_TOKEN_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        token: INITIAL_STATE.token,
      };

    default:
      return state;
  }
};

export default reducer;
